const React = require('react');
const PropTypes = require('prop-types');
const { Bar, Legend, ReferenceLine, Tooltip } = require('recharts');
const YearlyBarsLinesChart = require('components/charts/YearlyBarsLinesChart/YearlyBarsLinesChart');
const CustomTooltip = require('./CustomTooltip');
const CustomLegend = require('./CustomLegend');

const ProfitabilityChart = ({ benchmark, data, fund }) => (
    <YearlyBarsLinesChart
        data={data}
        height={400}
        tickFormatter={v => `${v}%`}
        width="100%"
    >
        <Bar dataKey="value" fill="#2ccefd" name={fund.name} unit="%" />
        <Bar
            dataKey="benchmark"
            fill="#69788c"
            name={benchmark.name}
            unit="%"
        />
        <Legend content={<CustomLegend />} />
        <ReferenceLine y={0} stroke="#68748c" />
        <Tooltip content={<CustomTooltip />} />
    </YearlyBarsLinesChart>
);

ProfitabilityChart.propTypes = {
    benchmark: PropTypes.object.isRequired,
    data: PropTypes.array.isRequired,
    fund: PropTypes.object.isRequired,
};

module.exports = ProfitabilityChart;
